const useBuildStyle = () => {
  const buildStyle = (styles) => {
    
    var style={};
    Object.entries(styles)//JSON.parse(JSON.stringify(
        .map(([toolName, toolValue]) => { style[toolName]= toolValue.value });
    return style
   
  };

  return buildStyle;
};

export default useBuildStyle;
